function SystemSettingService(ApiService) {
  'ngInject';

  const service = {};

  service.systemSetting = function(callbackFunc) {
    ApiService.get('/system_settings.json', callbackFunc);
  };

  service.toggleBulkCost =  function( callbackFunc){
    ApiService.post('/system_settings/toggle_bulk_cost.json', {}, callbackFunc);
  };
  
  service.saveSystemSetting =  function( data, callbackFunc){
    ApiService.post('/system_settings/update_setting.json', {'system_setting': data}, callbackFunc);
  };
  
  return service;
}

export default {
  name: 'SystemSettingService',
  fn: SystemSettingService
};
